import React from 'react'
import { storesContext } from '@stores/index.js'

export const useStores = () => React.useContext(storesContext)